import api from "./api";

export const exemplarApi = {
  // Ausleihe
  ausleihen: async (exemplarId: number, mitgliedId: number) => {
    const res = await api.post(
      `/user/buch/exemplar/${exemplarId}/ausleihen?mitgliedId=${mitgliedId}`,
    );
    return res.data;
  },

  //Zurückgeben
  zurueckgeben: async (exemplarId: number, mitgliedId: number) => {
    const res = await api.post(
      `/user/buch/exemplar/${exemplarId}/zurueckgeben/${mitgliedId}`,
    );
    return res.data;
  },

  // Reservierung
  reservieren: async (exemplarId: number, mitgliedId: number) => {
    const res = await api.post(
      `/user/buch/exemplar/${exemplarId}/reservieren`,
      null,
      { params: { mitgliedId } },
    );
    return res.data;
  },

  // Reservierung aufheben
  reservierungAufheben: async (exemplarId: number, mitgliedId: number) => {
    const res = await api.post(
      `/user/buch/exemplar/${exemplarId}/reservierung-aufheben`,
      null,
      { params: { mitgliedId: mitgliedId.toString() } },
    );
    return res.data;
  },
};
